import React from 'react'
import { Table } from '../../../dpe-usco'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import FormatCircles from '../../../components/subComponents/FormatCircles'

const headerContent = value => {
  return (
    <div key={value} className='cell df aic'>
      <span className='w100% tac'>{value}</span>
    </div>
  )
}

const summaryStructure = {
  headers: [
    {
      value: '', 
      format() {
        return (<div key='blank' className='flx1'/>)
      }
    },
    {
      value: 'Planter', 
      format() {
        return headerContent(this.value)
      }
    },
    {
      value: 'Harvest', 
      format() {
        return headerContent(this.value)
      }
    },
    {
      value: 'Storage', 
      format() {
        return headerContent(this.value)
      }
    }
  ],
  dataKeys: [
    'complete',
    'planting_summary',
    'harvest_summary',
    'storage_summary'
  ],
  rowFormat: {
    planting_summary: {
      overwriteStyles: true,
      customStyle: 'df flx1 jcc mr1%',
      format: val => {
        return FormatCircles(val)
      }
    },
    harvest_summary: {
      overwriteStyles: true,
      customStyle: 'df flx1 jcc mr1%',
      format: val => {
        return FormatCircles(val)
      }
    },
    storage_summary: {
      overwriteStyles: true,
      customStyle: 'df flx1 jcc mr1%',
      format: val => {
        return FormatCircles(val)
      }
    }
  }
}

const CleanoutSummary = ({ status, data }) => {
  return (
    <Table dataTestId='cleanoutSummary' data={data} structure={summaryStructure} statusComponent={status ? <TableStatus status={status}/> : null}/>
  )
}

export default CleanoutSummary